module.exports = __webpack_public_path__ + "img/Hellenic_Post.14221ff3.png";